import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteResumenOyvService{
    public api_url: string;
    public modulo_url: string;
    public service_url: string;
    constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
        this.api_url = this.constantService.apiURL;
        this.modulo_url = '/reportes/reporte-resumen-oyv';
        this.service_url = this.api_url + this.modulo_url;
    }


    getFechaReporte(fecha, fechaFinal) {
        return this.http.get(this.service_url + '/generar/fecha?fechaInicial=' + fecha + '&fechaFinal=' + fechaFinal, this.authService.getAuthHeaders());
    }

    getReporteOyvFecha(idObras, fecha) {
        return this.http.get(this.service_url + '/generar/reporte?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
    }

    getReporteOyvTotales(idObras, fecha, isResumenDeDiferencias) {
        let response = this.http.get(this.service_url + '/generar/totales?fecha=' + fecha + '&obra=' + idObras + '&isResumenDeDiferencias='+ isResumenDeDiferencias, this.authService.getAuthHeaders());
        console.log(response);
        return response;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/reporte-resumen-oyv.service.ts